import React, { useState } from "react";
import PanelRightContent from "../../../layouts/mainPanel/PanelRightContent";
import MainPanelHeader from "../../../layouts/mainPanelHeader";
import PanelLeftContent from "../../../layouts/mainPanel/PanelLeftContent";
import SmallCoin from "../../../asset/image/small-coin.png";
import { Tab, Tabs } from "react-bootstrap";
import { ReactComponent as OtherDots } from "../../../asset/icons/otherDotsIcon.svg";
import { ReactComponent as WalletIcon } from "../../../asset/icons/walletIcon.svg";

import Bests from "./Bests";
import {
    CartesianGrid,
    Line,
    LineChart,
    ResponsiveContainer,
    XAxis,
    YAxis,
} from "recharts";
import { useTranslation } from "react-i18next";

const data = [
    {
        name: "مهر",
        uv: 20,
        pv: 80,
    },
    {
        name: "آبان",
        uv: 60,
        pv: 60,
    },
    {
        name: "آذر",
        uv: 40,
        pv: 50,
    },
    {
        name: "دی",
        uv: 80,
        pv: 7,
    },
    {
        name: "بهمن",
        uv: 60,
        pv: 10,
    },
];

export default function UserBests() {
    const [activeTab, setActiveTab] = useState();
    const [completeProfile, setComleteProfile] = useState(50);
    const { t } = useTranslation();

    return (
        <div id="user-bests" className=" main_panel_box user-profile">
            <MainPanelHeader />
            <div className="best-page-container main_panel_content">
                <PanelRightContent>
                    <div className="tab-section">
                        <Tabs
                            activeKey={activeTab}
                            transition={false}
                            className="panel_tab"
                            onSelect={(e) => setActiveTab(e)}
                        >
                            <Tab
                                eventKey="1"
                                className="panel_tab_item"
                                title={t("UserPanel.BestOffers.BestOfers.Tab")}
                            >
                                <Bests />
                            </Tab>
                            <Tab
                                eventKey="2"
                                className="panel_tab_item"
                                title={t("UserPanel.BestOffers.Favorites.Tab")}
                            ></Tab>
                        </Tabs>
                    </div>
                </PanelRightContent>
                <PanelLeftContent>
                    <div class="left-section">
                        <div className="chart-title">
                            <img src={SmallCoin} alt="" />
                            <span>
                                {t(
                                    "UserPanel.Offers&Exchange.DiscountCard.CustomerClubShowcase.Chart"
                                )}
                            </span>
                            <button className="more-dots ratings-btn">
                                <OtherDots />
                            </button>
                        </div>
                        <div className="charts">
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart
                                    width={500}
                                    height={300}
                                    data={data}
                                    margin={{
                                        top: 10,
                                        right: 0,
                                        left: -40,
                                        bottom: -10,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis tickMargin={15} />
                                    <Line
                                        type="monotone"
                                        dataKey="uv"
                                        stroke="#FEB730"
                                        strokeWidth={2}
                                        activeDot={{ r: 8 }}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    <div class="left-section">
                        <div className="chart-title">
                            <img src={SmallCoin} alt="" />
                            <span>
                                {t(
                                    "UserPanel.Offers&Exchange.DiscountCard.CustomerClubShowcase.Chart"
                                )}
                            </span>
                            <button className="more-dots ratings-btn">
                                <OtherDots />
                            </button>
                        </div>
                        <div className="charts">
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart
                                    width={500}
                                    height={300}
                                    data={data}
                                    margin={{
                                        top: 10,
                                        right: 0,
                                        left: -40,
                                        bottom: -10,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis tickMargin={15} />
                                    <Line
                                        type="monotone"
                                        dataKey="uv"
                                        stroke="#FEB730"
                                        strokeWidth={2}
                                        activeDot={{ r: 8 }}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    <div class="left-section">
                        <div className="chart-title">
                            <WalletIcon />
                            <div>
                                {t(
                                    "UserPanel.Offers&Exchange.DiscountCard.Wallet.Label"
                                )}
                            </div>
                        </div>
                        <div className="wallet">
                            <div>
                                {t(
                                    "UserPanel.Offers&Exchange.DiscountCard.WalletBalance.Label"
                                )}
                            </div>
                            <div>
                                تومان<span>2500000</span>
                            </div>
                            <div className="btn-group">
                                <button className=" blue">
                                    {t(
                                        "UserPanel.Offers&Exchange.DiscountCard.WalletRecharge.Button"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </PanelLeftContent>
            </div>
        </div>
    );
}
